module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTitleSection[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayAddOrganization) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [(_vm.flagDisplayTable) ? _c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddOrganization[_vm.actualLanguage]))]) : _vm._e()]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCancel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelOrganizationToAddId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationToAddId),
      expression: "organizationToAddId"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": "XXXXX"
    },
    domProps: {
      "value": (_vm.organizationToAddId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organizationToAddId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelOrganizationToPhoneNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationToAddPhoneNumber),
      expression: "organizationToAddPhoneNumber"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": "XXX-XXX-XXXX"
    },
    domProps: {
      "value": (_vm.organizationToAddPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organizationToAddPhoneNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addNewOrganisation()
      }
    }
  }, [(_vm.organizationIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAdd[_vm.actualLanguage]))])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [(_vm.organizationListIsLoading) ? _c('spinner', {
    attrs: {
      "size": "normal"
    }
  }) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [(_vm.flagDisplayTable) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.labelOrganizationTableColumn1[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.labelOrganizationTableColumn2[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.labelOrganizationTableColumn3[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.labelOrganizationTableColumn4[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.managedOrganizations), function(subOrganization, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v("\r\n                        " + _vm._s(subOrganization.organizationName) + " [" + _vm._s(subOrganization.organizationId) + "]\r\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\r\n                        " + _vm._s(subOrganization.subscriptionTitle[_vm.actualLanguage]) + "\r\n                      ")]), _vm._v(" "), (subOrganization.subscriptionActive) ? _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-block  btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip"
      },
      on: {
        "click": function($event) {
          return _vm.openApplyPlanToSubOrganization(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" " + _vm._s(_vm.labelTableApplyPlan[_vm.actualLanguage]))]), _vm._v(" "), (subOrganization.subscriptionActive) ? _c('button', {
      staticClass: "btn btn-block btn-default btn-block",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip"
      },
      on: {
        "click": function($event) {
          return _vm.openModifyPlanToSubOrganization(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" " + _vm._s(_vm.labelTableModifyPlan[_vm.actualLanguage]))]) : _vm._e()])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayAddPlan) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.cancelAddModifyPlan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCancel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h4', [_vm._v(_vm._s(_vm.labelApplyPlanTo[_vm.actualLanguage]) + " " + _vm._s(_vm.managedOrganizations[_vm.selectedOrganizationIndex].organizationName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelActualPlan[_vm.actualLanguage]) + " " + _vm._s(_vm.managedOrganizations[_vm.selectedOrganizationIndex].subscriptionTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPlanSortKey),
      expression: "selectedPlanSortKey"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.readSelectedPlanDetail()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPlanSortKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.planDescription), function(plan) {
    return _c('option', {
      domProps: {
        "value": plan.sort_key
      }
    }, [_vm._v(_vm._s(plan.planInfo.title[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), (_vm.selectedPlanSortKey.length > 3 & _vm.planSelectedFlag) ? _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('div', {
    staticClass: "col-xm-12 col-md-12"
  }, [_c('a', {
    staticClass: "block block-bordered block-link-hover3 text-center"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.planInfo.title[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.selectedPlanDetail.planInfo.description), function(descriptionLine, index) {
    return _c('div', {
      staticClass: "col-xm-12 col-md-12"
    }, [_c('h6', {
      staticClass: "font-w200 text-center push"
    }, [_vm._v(_vm._s(descriptionLine[_vm.actualLanguage]))])])
  }), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionOrgLicenceSection[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.organizationLicenceData.licenceTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.organizationLicenceData.priceDescription[_vm.actualLanguage]) + " : ")]), _vm._v(" "), _c('h5', {
    staticClass: "h1 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.organizationLicenceData.price) + " $ ")]), _vm._v(" "), (_vm.selectedPlanDetail.organizationLicenceData.options.length > 100) ? _c('div', [_c('h5', {
    staticClass: "content-heading align-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionLicenceOptionSection[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.selectedPlanDetail.organizationLicenceData.options), function(optionLine, optionIndex) {
    return _c('div', {
      key: optionIndex,
      staticClass: "col-xm-12 col-md-12"
    }, [_c('h5', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine.title[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine.description[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine.priceDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "h3 font-w700 push-10"
    }, [_vm._v(_vm._s(optionLine.price) + " $ ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), (parseFloat(_vm.selectedPlanDetail.planInfo.maximumLicenceCount) > parseFloat(_vm.selectedPlanDetail.planInfo.includedLicence)) ? _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionUserLicenceSection[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.userLicenceData.licenceTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.userLicenceData.priceDescription[_vm.actualLanguage]) + " : ")]), _vm._v(" "), _c('h5', {
    staticClass: "h1 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.userLicenceData.price) + " $ ")]), _vm._v(" "), (_vm.selectedPlanDetail.userLicenceData.options.length > 100) ? _c('div', [_c('h5', {
    staticClass: "content-heading align-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionLicenceOptionSection[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.selectedPlanDetail.userLicenceData.options), function(optionLine2, optionIndex2) {
    return _c('div', {
      key: optionIndex2,
      staticClass: "col-xm-12 col-md-12"
    }, [_c('h5', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine2.title[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine2.description[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine2.priceDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "h3 font-w700 push-10"
    }, [_vm._v(_vm._s(optionLine2.price) + " $ ")])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.textRebateTableTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.textRebateTableSubTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.textRebateTableColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.textRebateTableColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.textRebateTableColumn03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedPlanDetail.rebateChartData.chart), function(rebateSlice) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(rebateSlice.priceSliceMin) + " $")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(rebateSlice.priceSliceMax) + " $")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(rebateSlice.pourcentageReduction) + " %")])])
  }), 0)])])], 2)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyPlanToSelectedOrganization()
      }
    }
  }, [(_vm.planIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonActualPlan[_vm.actualLanguage]))])], 1)]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayModifyPlan) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelModifyOrganizationPlan[_vm.actualLanguage]))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.managedOrganizations[_vm.selectedOrganizationIndex].organizationName))]), _vm._v(" "), (_vm.subscriptionIsLoading) ? _c('spinner', {
    attrs: {
      "size": "normal"
    }
  }) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.cancelAddModifyPlan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCancel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.sectionLabelLicenceOrganization[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.subOrganizationSubscription.organization_licence.title[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-6"
  }, [_c('h4', [_vm._v("Licence ID:" + _vm._s(_vm.subOrganizationSubscription.subscription_id.substring(11, 30)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-6 "
  }, [_c('h3', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.baseCostLabel[_vm.actualLanguage]) + " : " + _vm._s(_vm.subOrganizationSubscription.organization_licence.price) + " $")])]), _vm._v(" "), (_vm.subOrganizationSubscription.organization_licence.customizedOptions.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.subOrganizationSubscription.organization_licence.customizedOptions), function(licenceOption, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(licenceOption.title[_vm.actualLanguage]) + ".  " + _vm._s(licenceOption.priceDescription[_vm.actualLanguage]) + ":" + _vm._s(licenceOption.price) + " $ ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(licenceOption.description[_vm.actualLanguage]))]), _vm._v(" "), (licenceOption.valueType == 'NUMERIC') ? _c('td', {
      staticClass: "text-center"
    }, [_c('h6', {
      staticClass: "h6 font-w700 push-10"
    }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (licenceOption.value),
        expression: "licenceOption.value"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (licenceOption.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(licenceOption, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (licenceOption.valueType == 'BOOL') ? _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (licenceOption.value),
        expression: "licenceOption.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(licenceOption.value) ? _vm._i(licenceOption.value, null) > -1 : (licenceOption.value)
      },
      on: {
        "change": function($event) {
          var $$a = licenceOption.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(licenceOption, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(licenceOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(licenceOption, "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" Activation\r\n                                            ")])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.labelOtherCostSection[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.subOrganizationSubscription.subscription_other_fees.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.otherFeeColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.otherFeeColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.otherFeeColumnTitle03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.otherFeeColumnTitle04[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.subOrganizationSubscription.subscription_other_fees), function(fee, indexFee) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (fee.quantity),
        expression: "fee.quantity"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (fee.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(fee, "quantity", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fee.description[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (fee.unitCost),
        expression: "fee.unitCost"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (fee.unitCost)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(fee, "unitCost", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-md btn-danger align-center",
      attrs: {
        "type": "button",
        "title": "Retirer/Release"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFeeLine(indexFee)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.flagAddOtherFeeSection == false) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right push",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openAddOtherFee()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonAddOtherFees[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFeeToAdd),
      expression: "selectedFeeToAdd"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFeeToAdd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.otherFeesList), function(fee) {
    return _c('option', {
      domProps: {
        "value": fee.data
      }
    }, [_vm._v(_vm._s(fee.data.description[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), (_vm.selectedFeeToAdd.quantity) ? _c('p', [_c('button', {
    staticClass: "btn btn-success align-right push",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addSelectedFee()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonAddSelectedFees[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-danger align-right push",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeAddOtherFee()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonAddOtherFeesCancel[_vm.actualLanguage]))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSubscriptionModification()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonSaveSupscription[_vm.actualLanguage]))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.sectionLabelLicence[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.displayUserLicenceSectionFLag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, _vm._l((_vm.subOrganizationSubscription.organization_user_licences), function(userLicence, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-key"
    })])])]), _vm._v(" "), _c('h3', {
      staticClass: "block-title",
      on: {
        "click": function($event) {
          return _vm.toggleDisplayUserLicenceFlag(index)
        }
      }
    }, [_vm._v(_vm._s(userLicence.title[_vm.actualLanguage]) + " ID: " + _vm._s(userLicence.licenceId.substring(11, 30)))])]), _vm._v(" "), (_vm.displayUserLicenceFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "col-sm-12 col-lg-12 push"
    }, [_c('div', {
      staticClass: "col-sm-12 col-lg-12 "
    }, [_c('h3', {
      staticClass: "align-right"
    }, [_vm._v(_vm._s(_vm.baseCostLabel[_vm.actualLanguage]) + " : " + _vm._s(userLicence.price) + " $")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-12 push"
    }, [_c('div', {
      staticClass: "col-sm-6 col-lg-6 "
    }, [(userLicence.linkedProfile.email != 'NONE') ? _c('h3', {
      staticClass: "align-left"
    }, [_vm._v(_vm._s(_vm.tableLicenceUser[_vm.actualLanguage]) + " : " + _vm._s(userLicence.linkedProfile.email))]) : _c('h3', {
      staticClass: "align-left"
    }, [_vm._v("Disponible/Available")])])]), _vm._v(" "), (userLicence.linkedProfile.email == 'NONE' && index >= _vm.subOrganizationSubscription.organization_plan_description.planInfo.includedLicence) ? _c('div', {
      staticClass: "col-sm-12 col-lg-12"
    }, [_c('button', {
      staticClass: "btn btn-md btn-danger align-right",
      attrs: {
        "type": "button",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLicence(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" " + _vm._s(_vm.buttonLabelDeleteLicence[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [(userLicence.customizedOptions.length > 0) ? _c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((userLicence.customizedOptions), function(licenceOption, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(licenceOption.title[_vm.actualLanguage]) + ".  " + _vm._s(licenceOption.priceDescription[_vm.actualLanguage]) + ":" + _vm._s(licenceOption.price) + " $ ")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(licenceOption.description[_vm.actualLanguage]))]), _vm._v(" "), (licenceOption.valueType == 'NUMERIC') ? _c('td', {
        staticClass: "text-center"
      }, [_c('h6', {
        staticClass: "h6 font-w700 push-10"
      }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (licenceOption.value),
          expression: "licenceOption.value"
        }],
        staticClass: "form-control text-center",
        attrs: {
          "placeholder": "Valeur/Value"
        },
        domProps: {
          "value": (licenceOption.value)
        },
        on: {
          "change": function($event) {
            return _vm.computeCost()
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(licenceOption, "value", $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (licenceOption.valueType == 'BOOL') ? _c('td', {
        staticClass: "text-center"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (licenceOption.value),
          expression: "licenceOption.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(licenceOption.value) ? _vm._i(licenceOption.value, null) > -1 : (licenceOption.value)
        },
        on: {
          "change": [function($event) {
            var $$a = licenceOption.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(licenceOption, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(licenceOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(licenceOption, "value", $$c)
            }
          }, function($event) {
            return _vm.computeCost()
          }]
        }
      }), _vm._v(" "), _c('span'), _vm._v(" Activation\r\n                                            ")])]) : _vm._e()])
    }), 0)])]) : _vm._e()])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Date dernier renouvellement / Last renewal date :   " + _vm._s(_vm.subOrganizationSubscription.renewal_last_date))]), _vm._v(" "), _c('h5', {
    staticClass: "push"
  }, [_vm._v("Date prochain renouvellement / Next renewal date :   " + _vm._s(_vm.subOrganizationSubscription.renewal_date))]), _vm._v(" "), _c('h5', [_vm._v("Type de paiement / Paiement type :   " + _vm._s(_vm.subOrganizationSubscription.payment_type))])])])], 1) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71019068","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/Integrator/IntegratorSubOrganization.vue
// module id = 1564
// module chunks = 4